import {
  AppstoreOutlined,
  AreaChartOutlined,
  BookOutlined,
  BorderOuterOutlined,
  ClockCircleOutlined,
  DesktopOutlined,
  MessageOutlined,
  NumberOutlined,
  PhoneOutlined,
  PlayCircleOutlined,
  SnippetsOutlined,
  SolutionOutlined,
  TeamOutlined,
  UsergroupAddOutlined,
  UserOutlined,
} from '@ant-design/icons';

export const ROUTES = {
  LOGIN_ROUTE: '/login',
  MAIN_ROUTE: '/',
  DIRECTORY_ROUTE: '/directory/:directoryName',
  OFFLINE_DIRECTORY_ROUTE: '/device_offline',
  CHART_ROUTE: '/app',
  MAPS_ROUTE: '/map',
  STATISTICS_ROUTE: '/statistics',
  GEO_ROUTE: '/geo',
  CALL_PAGE_ROUTE: '/call_page',
  ROOM_PAGE_ROUTE: '/room/:id/:fullRoomName/:wantsEnableAudio/:wantsEnableVideo/:selectedBitrate',
  GROUP_CALL_PAGE_ROUTE: '/webrtc_translations',
  MESSAGES_ROUTE: '/messages',
  REG_REQUESTS_ROUTE: '/registered',
  TRANSLATION_ROUTE: '/translation',
  USERS_ROUTE: '/users',
  USERS_REQUESTS_ROUTE: '/users_requests',
  GROUP_TRANSLATIONS_ROUTE: '/group_translations',
  LOCALMACHINE_REQUESTS_ROUTE: '/localmachine_registration',
  FORWARDER_ROUTE: '/directory/forwarder',
  GLOBAL_SITUATION_ROUTE: '/globalSituation',
  USERS_STATISTICS_ROUTE: '/usersStatistics',
  SERIAL_ROUTE: '/serial',
  PROFILE: '/profile',
};

export const NAVIGATION_ITEMS = {
  FORWARDER: {
    link: ROUTES.FORWARDER_ROUTE,
    key: 'forwarder',
    label: 'Список устройств',
    icon: <SnippetsOutlined style={{ fontSize: '22px' }} />,
  },
  MESSAGES: {
    link: ROUTES.MESSAGES_ROUTE,
    key: 'messages',
    label: 'Сообщения',
    icon: <MessageOutlined style={{ fontSize: '22px' }} />,
  },
  APP: {
    link: ROUTES.CHART_ROUTE,
    key: 'app',
    label: 'Приложения',
    icon: <AppstoreOutlined style={{ fontSize: '22px' }} />,
  },
  GEO: {
    link: ROUTES.GEO_ROUTE,
    key: 'geo_data',
    label: 'Геоданные',
    icon: <BorderOuterOutlined style={{ fontSize: '22px' }} />,
  },
  // MAPS: { link: ROUTES.MAPS_ROUTE, key: "maps", label: 'Карты', icon: <ReadOutlined /> },
  REGISTERED: {
    link: ROUTES.REG_REQUESTS_ROUTE,
    key: 'registration_requests',
    label: 'Запросы',
    icon: <ClockCircleOutlined style={{ fontSize: '22px' }} />,
  },
  TRANSLATION: {
    link: ROUTES.TRANSLATION_ROUTE,
    key: 'translation',
    label: 'Трансляции',
    icon: <PlayCircleOutlined style={{ fontSize: '22px' }} />,
  },
  USERS: {
    link: ROUTES.USERS_ROUTE,
    key: 'users',
    label: 'Пользователи',
    icon: <TeamOutlined style={{ fontSize: '22px' }} />,
  },
  USERS_REQUESTS: {
    link: ROUTES.USERS_REQUESTS_ROUTE,
    key: 'new_user_requests',
    label: 'Добавление пользователей',
    icon: <SolutionOutlined style={{ fontSize: '22px' }} />,
  },
  GROUP_TRANSLATIONS: {
    link: ROUTES.GROUP_TRANSLATIONS_ROUTE,
    key: 'group_translations',
    label: 'Групповые трансляции',
    icon: <UsergroupAddOutlined style={{ fontSize: '22px' }} />,
  },
  DEVICE_OFFLINE: {
    link: ROUTES.OFFLINE_DIRECTORY_ROUTE,
    key: 'device_offline',
    label: 'Оффлайн устройства',
    icon: <BookOutlined style={{ fontSize: '22px' }} />,
  },
  STATISTICS: {
    link: ROUTES.STATISTICS_ROUTE,
    key: 'statistics',
    label: 'Статистика',
    icon: <AreaChartOutlined style={{ fontSize: '22px' }} />,
  },
  CALL_PAGE: {
    link: ROUTES.CALL_PAGE_ROUTE,
    key: 'call_page',
    label: 'Звонки',
    icon: <PhoneOutlined style={{ fontSize: '22px' }} />,
  },
  LOCAL_MACHINE_REGISTRATION: {
    link: ROUTES.LOCALMACHINE_REQUESTS_ROUTE,
    key: 'localmachine_registration',
    label: 'Локальные сервера',
    icon: <DesktopOutlined style={{ fontSize: '22px' }} />,
  },
  PROFILE: {
    link: ROUTES.PROFILE,
    key: 'profile',
    label: 'Профиль',
    icon: <UserOutlined style={{ fontSize: '22px' }} />,
  },
  SERIAL: {
    link: ROUTES.SERIAL_ROUTE,
    key: 'serial',
    label: 'Серии',
    icon: <NumberOutlined style={{ fontSize: '22px' }} />,
  },
};
